module.exports = __webpack_public_path__ + "media/src/components/Footer/LicenseSection/khqr-ef45e194e6a746079a1997f89e8d90e9.png";